/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Ai_AInputs */

const en_wc_faq_ai_a = /** @type {(inputs: Wc_Faq_Ai_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft builds its Crafting Apps with the help of AI coding tools, which is how a small team could reimplement a Word-class editor so quickly. The code is a clean-room implementation written in Rust from public specifications, and it is all open for anyone to read.`)
};

/**
* | output |
* | --- |
* | "ArtCraft builds its Crafting Apps with the help of AI coding tools, which is how a small team could reimplement a Word-class editor so quickly. The code is a..." |
*
* @param {Wc_Faq_Ai_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_ai_a = /** @type {((inputs?: Wc_Faq_Ai_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Ai_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_ai_a(inputs)
});
export { wc_faq_ai_a as "wc.faq.ai.a" }